module.exports = "\r\n\r\n<a class=\"btn-link\" (click)=\"tooltipOpen=!tooltipOpen\">{{title}}</a>\r\n<div class=\"tooltip\" *ngIf=\"tooltipOpen\">\r\n  <a (click)=\"tooltipOpen=false\" class=\"btn-close btn-close-white btn-close-xs\"></a>\r\n  <a href=\"{{url}}\" *ngIf=\"url\"><span>{{text}}</span></a>\r\n  <span *ngIf=\"!url\">{{text}}</span>\r\n</div>  "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tooltip/tooltip.component.html
// module id = ./src/app/components/tooltip/tooltip.component.html
// module chunks = main